import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  OutlinedInput,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  BUGS_OPT,
  CHATBOT_ICON_OPT,
  CHATBOT_SEND_ICON_OPT,
  FEATURE_OPT,
  FEEDBACK_OPT,
  IProductParams,
  MAIN_BUTTON,
} from "../../../model";
import { appLogger } from "../../../utils";
import DOMPurify from "dompurify";

const IconUpload = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "handleChange",
      component: "add-product",
      fileName: "iconUpload.tsx",
      props: props,
    },
  });
  const { label, iconType, iconStr, productParams, setProductParams } = props;
  const [icon, setIcon] = useState("");
  const [base64data, setBase64] = useState<string | undefined>();
  const [success, setSuccess] = useState(false);
  const [failiure, setFailure] = useState(false);

  useEffect(() => {
    if (iconStr) {
      const returnedIcon = iconStr.replace(
        /\<\?xml.+\?\>|\<\!DOCTYPE.+]\>/g,
        ""
      );
      //   convertSVG(returnedIcon);
      setIcon(returnedIcon);
    } else {
      setIcon("");
    }
    // }
    // }, [product])
  }, [iconStr]);

  const handleIconChange = (event: any) => {
    const { type, iconStr } = event;
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (temp && temp.products && temp.products[0] && temp.products[0]) {
        switch (type) {
          case FEEDBACK_OPT: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.feedbackSettings
            ) {
              temp.products[0].feedbackAgentSettings.feedbackSettings.icon =
                iconStr;
            }
            break;
          }
          case BUGS_OPT: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.bugSettings
            ) {
              temp.products[0].feedbackAgentSettings.bugSettings.icon = iconStr;
            }
            break;
          }
          case FEATURE_OPT: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.featureReqSettings
            ) {
              temp.products[0].feedbackAgentSettings.featureReqSettings.icon =
                iconStr;
            }
            break;
          }
          case CHATBOT_ICON_OPT: {
            if (temp.products[0].chatAgentSettings) {
              temp.products[0].chatAgentSettings.chatbotIcon = iconStr;
            }
            break;
          }
          case CHATBOT_SEND_ICON_OPT: {
            if (temp.products[0].chatAgentSettings) {
              temp.products[0].chatAgentSettings.sendIcon = iconStr;
            }
            break;
          }
          case MAIN_BUTTON:
          default: {
            if (
              temp.products[0].feedbackAgentSettings &&
              temp.products[0].feedbackAgentSettings.widgetLookAndFeel
            ) {
              temp.products[0].feedbackAgentSettings.widgetLookAndFeel.icon =
                iconStr;
            }
          }
        }
        setProductParams(temp);
      }
    }
  };

  const handleIconDelete = () => {
    setIcon("");
    setBase64("");
    handleIconChange({ type: iconType, iconStr: "" });
  };

  useEffect(() => {
    if (icon) {
      setBase64("data:image/svg+xml;base64," + window.btoa(icon));
    }
  }, [icon]);

  const handleIconUpdate = (event: any) => {
    setIcon(event.target.value);
    handleIconChange({ type: iconType, iconStr: event.target.value });
  };

  const handleClose = () => {
    setFailure(false);
    setSuccess(false);
  };

  const handleChange = (event: any) => {
    const file = event.target.files[0];
    appLogger.info({
      infoObj: {
        method: "handleChange",
        component: "add-product",
        fileName: "iconUpload.tsx",
        file: file,
      },
    });
    const fileType = event.target.files[0].type;
    if (fileType === "image/svg+xml") {
      const reader = new FileReader();
      reader.onload = function (event) {
        if (event.target !== null && event.target && event.target.result) {
          if (typeof event.target.result === "string") {
            const resultString: any = event.target.result?.toString();
            setIcon(DOMPurify.sanitize(resultString));
            setSuccess(true);
            handleIconChange({
              type: iconType,
              iconStr: DOMPurify.sanitize(resultString),
            });
          }
        }
      };
      reader.onerror = function (event) {
        appLogger.error(
          {
            errObj: {
              method: "handleChange",
              component: "add-product",
              fileName: "iconUpload.tsx",
              err: new Error("Error uploading svg file"),
            },
          },
          "Error while uploading the svg file"
        );
        reader.abort();
      };
      reader.readAsText(file);
    } else {
      appLogger.info(
        {
          infoObj: {
            method: "handleChange",
            component: "add-product",
            fileName: "iconUpload.tsx",
          },
        },
        "File type is different"
      );
      setFailure(true);
    }
  };
  return (
    <Grid item xs={12}>
      <Box className="upload-wrap" sx={{ display: "flex" }}>
        <Grid className="upload-area">
          <FormControl className="custom-select custom-textarea" fullWidth>
            <InputLabel>{label}</InputLabel>
            <OutlinedInput
              type="text"
              value={icon}
              onChange={(event) => handleIconUpdate(event)}
              id="xml-input"
              label="xml"
              multiline
              maxRows={4}
            />
          </FormControl>
        </Grid>

        {!base64data && (
          <Button
            variant="outlined"
            component="label"
            className="upload-btn"
            // onChange={(e: any) => setSelectedImage(e.target.files[0])}
          >
            <i className="icon-upload" />
            upload svg icon
            <input
              hidden
              accept="image/svg+xml"
              onChange={(e) => handleChange(e)}
              type="file"
            />
          </Button>
        )}

        {base64data && (
          <Box className="img-preview">
            <img src={`${base64data}`} />
          </Box>
        )}

        {base64data && (
          <i
            className="icon-delete cursor-pointer"
            onClick={handleIconDelete}
          />
        )}
        {success ? (
          <>
            {" "}
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={success}
              onClose={handleClose}
              autoHideDuration={2000}
            >
              <Alert> Svg file uploaded successfully</Alert>
            </Snackbar>
          </>
        ) : (
          <></>
        )}
        {failiure ? (
          <>
            {" "}
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              open={failiure}
              onClose={handleClose}
              autoHideDuration={2000}
            >
              <Alert severity={"error"}>
                {" "}
                File type error: Upload Svg Xml File
              </Alert>
            </Snackbar>
          </>
        ) : (
          <></>
        )}
      </Box>
    </Grid>
  );
};

export default IconUpload;
